import { push } from 'redux-first-history';
import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';
import { keyByProperty } from '../../../../helpers/core';
import { t } from '../../../../i18n';

const api = new Api('demo_users/:id');
const demoUsersListApi = new Api('demo_users');

function* loadData({ payload }) {
  try {
    const { id, isEdit } = payload;
    const result = yield call(sendRequest, api.load, { id }, notifications.REQUEST_ERROR);

    if (result) {
      const { data } = result;

      yield put(actions.loadDataSuccess({ data }));

      if (isEdit) {
        yield put(actions.edit({ id, demoUser: { ...data } }));
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* updateUser(data) {
  try {
    const { payload } = data;
    const { editForm, id } = payload;

    const propsArray = Object.values(editForm);
    const manager = keyByProperty(propsArray, 'name', prop => prop.value);

    const result = yield call(
      sendRequest,
      api.updateItem,
      {
        data: { manager },
        id,
      },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      if (result.data) {
        yield put(actions.saveSuccess({ data: manager }));

        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: t('dash.common.notification.updated_successfully', {
              item: t('dash.admin.demoUsers.demo_user_header'),
            }),
          }),
        );

        yield loadData({ payload: { id } });
      } else {
        yield put(actions.saveError({ data: result }));
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* addUser(data) {
  try {
    const { payload } = data;
    const { editForm } = payload;

    const propsArray = Object.values(editForm);
    const manager = keyByProperty(propsArray, 'name', prop => prop.value);

    const result = yield call(
      sendRequest,
      demoUsersListApi.createItem,
      {
        data: { manager },
      },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      if (result.data) {
        const { id } = result.data;
        yield put(actions.saveSuccess({ data: { ...manager, id } }));

        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: t('dash.common.notification.created_successfully', {
              item: t('dash.admin.demoUsers.demo_user_header'),
            }),
          }),
        );
        yield put(push('/demoUsers/'));
      } else {
        yield put(
          actions.saveError({
            data: result,
          }),
        );
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* deleteDemoUser(data) {
  try {
    const { payload } = data;
    const { id } = payload;

    const result = yield call(sendRequest, api.deleteItem, { id }, notifications.REQUEST_ERROR);

    if (result && result.data) {
      yield put(actions.deleteSuccess());
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.deleted_successfully', {
            item: t('dash.admin.demoUsers.demo_user_header'),
          }),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadFormData() {
  try {
    const result = yield call(sendRequest, api.loadFormData, {}, notifications.REQUEST_ERROR);

    if (result) {
      const { data } = result;

      yield put(actions.loadFormData({ data }));
    }
  } catch (error) {
    logger.error(error);
  }
}

export { loadData, updateUser, addUser, loadFormData, deleteDemoUser };
export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD, loadData),
    takeEvery(actions.SAVE, updateUser),
    takeEvery(actions.ADD, addUser),
    takeEvery(actions.EDIT, loadFormData),
    takeEvery(actions.DELETE, deleteDemoUser),
    takeEvery(actions.CREATE, loadFormData),
  ]);
}
